export default __webpack_public_path__ + "static/terence-53a43f56acd77c9fab47c95c16fc8c47.svg";